import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Endpoints } from '../services/endpoints';
import { CdxApiGatewayHttpService } from './cdx-api-gateway-http.service';

@Injectable()
export class FeeScheduleService {
  private http = inject(CdxApiGatewayHttpService);

  public getExchangeFeeSchedule(): Observable<object> {
    return this.http.post(Endpoints.EXCHANGE_FEE_SCHEDULE, JSON.stringify({}));
  }
}
